import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterReportStatusSelect ({ value, onChange = () => null, att }) {
  const { t } = useTranslate()

  const { reportStatuses } = useStoreState((state) => state.filter)

  const { getReportStatuses } = useStoreActions((actions) => actions.filter)

  const options = _.map(reportStatuses, (filterReportStatus) => {
    return {
      label: filterReportStatus?.name,
      value: filterReportStatus?.id,
    }
  })
  useAsync(async () => {
    getReportStatuses()
  }, [])

  return (
    <Styled className='filter-report-status-select-component'>
      <Select
        value={value}
        allowClear
        dropdownMatchSelectWidth={false}
        options={options}
        placeholder={t('Report Status')}
        onChange={onChange}
        {...att}
      />
    </Styled>
  )
}
